<template>
  <div class="box6_main">
    <div class="messages" @click="$router.push('/device/alarm')">
      <div v-if="itemData.length" class="content-issue">
        <div class="item-one" v-for="(item, index) in itemData.slice(0, 4)" :key="index">
          <div class="item-text">{{$t("home.box6.text5")}}{{item.number}} {{$t("home.box6.text6")}} {{formatDate(item.created_at)}}</div>
          <div class="item-value">{{item.content}}</div>
          <span class="point p1"></span>
          <span class="point p2"></span>
          <span class="point p3"></span>
          <span class="point p4"></span>
        </div>
      </div>
      <div class="content-issue" v-else>
        <div class="none_data">{{$t("home.box6.text4")}}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Box6',
  props: {
    itemData: {
      type: Array,
      required: true,
      default: function () {
        return []
      }
    }
  },
  data() {
    return {
    }
  },
  methods: {
    formatDate(dateString) {
      const spaceIndex = dateString.indexOf(' ');
      if (spaceIndex === -1) {
          return dateString;
      }

      // 截取日期部分 (MM-DD)
      const datePart = dateString.substring(5, spaceIndex); // MM-DD
      
      // 截取时间部分 (HH:mm)，只取前面的两个字符
      const timePart = dateString.substring(spaceIndex, spaceIndex + 6); // HH:mm

      // 返回格式化后的字符串
      return `${datePart}${timePart}`;
    }
  }
};
</script>
<style lang='less' scoped>
.box6_main {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 30px;
  .messages {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    .content-issue{
      width: 100%;
      .item-one{
        display: flex;
        align-items: center;
        justify-content: space-between;
        border: 1px solid #153471;
        padding: 10px 20px;
        background-color: #03182d;
        position: relative;
        margin-bottom: 15px;
        .point{
          position: absolute;
          width: 5px;
          height: 5px;
          background-color: rgba(53, 115, 252, 0.4);
          &.p1{
            left:0;
            top:0;
            margin-left: -3px;
            margin-top: -3px;
          }
          &.p2{
            right:0;
            top:0;
            margin-right: -3px;
            margin-top: -3px;
          }
          &.p3{
            left:0;
            bottom:0;
            margin-left: -3px;
            margin-bottom: -3px;
          }
          &.p4{
            right:0;
            bottom:0;
            margin-right: -3px;
            margin-bottom: -3px;
          }
        }
        .item-text{
          font-size: 12px;
          color:#fff;
        }
        .item-value{
          font-size: 14px;
          font-weight: bold;
          color:#f0422a
        }
      }
    }
  }
  .none_data{
    font-size:14px;
    color: #7190a4;
    width:100%;
    height:100%;
    display: flex;
    justify-content: center; /* 水平居中 */
    align-items: center;     /* 垂直居中 */
    text-align:center;
  }
  
}


</style>